/* FRANK14 · FUORI TUTTO — il motore del movimento.
   Lenis per lo scroll, GSAP + ScrollTrigger per tutto il resto.
   Le sezioni non scrivono JS: dichiarano attributi e questo file li anima.

   ATTRIBUTI
     data-rivela                 sale ed entra quando arriva (data-rivela-ritardo, data-rivela-y)
     data-rivela-gruppo          i figli con [data-rivela-figlio] entrano a scalare
     data-parola                 il testo si spezza in parole che salgono da dietro una maschera
     data-parallasse="0.15"      si muove più lento dello scroll (negativo = più veloce)
     data-marquee                nastro infinito; le righe sono [data-marquee-riga]
                                 data-marquee-velocita, data-marquee-verso="-1"
     data-pin                    pista orizzontale; dentro, [data-pin-strada] è ciò che scorre
     data-conta                  il numero conta da zero
     data-magnetico              il bottone insegue il puntatore
     data-testa                  "scura" | "chiara": dice al header di che colore diventare
     data-arco                   l'arco dell'eroe si apre al caricamento

   Rispetta prefers-reduced-motion: niente Lenis, niente moto, tutto già visibile. */
(function () {
  var pigro = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var haGsap = typeof window.gsap !== 'undefined' && typeof window.ScrollTrigger !== 'undefined';
  if (haGsap) gsap.registerPlugin(ScrollTrigger);

  /* ---------- scroll morbido ---------- */
  var lenis = null;
  if (!pigro && haGsap && typeof window.Lenis !== 'undefined') {
    lenis = new Lenis({ lerp: 0.11, wheelMultiplier: 1, smoothWheel: true, touchMultiplier: 1.6 });
    lenis.on('scroll', ScrollTrigger.update);
    gsap.ticker.add(function (t) { lenis.raf(t * 1000); });
    gsap.ticker.lagSmoothing(0);
    document.documentElement.classList.add('ha-lenis');
    window.__lenis = lenis;

    /* LA PAGINA CRESCE DOPO: le fotografie pigre che si caricano mentre scorri,
       i capi suggeriti che arrivano dopo, la striscia dei visti di recente.
       Lenis calcola il fondo una volta sola e poi non lo tocca più: senza questo
       ricalcolo lo scorrimento si ferma dove finiva la pagina PRIMA, e l'ultimo
       pezzo — il piede — resta irraggiungibile. Succedeva davvero: scendendo con
       la rotella il documento passava da 3734 a 4530 px e il fondo restava a 2784. */
    (function () {
      var altezza = document.documentElement.scrollHeight;
      var attesa = null;
      function ricalcola() {
        var nuova = document.documentElement.scrollHeight;
        if (Math.abs(nuova - altezza) < 2) return;
        altezza = nuova;
        lenis.resize();
        if (haGsap) ScrollTrigger.refresh();
      }
      function chiedi() {
        window.clearTimeout(attesa);
        attesa = window.setTimeout(ricalcola, 180);
      }
      if (window.ResizeObserver) {
        new ResizeObserver(chiedi).observe(document.body);
      }
      window.addEventListener('load', chiedi);
      document.addEventListener('load', chiedi, true);   /* ogni immagine che finisce */
    })();
  }

  /* ---------- utilità: spezzare in parole ---------- */
  function spezza(el) {
    if (el.dataset.spezzato) return;
    var pezzi = [];
    (function cammina(nodo, dentro) {
      Array.prototype.slice.call(nodo.childNodes).forEach(function (n) {
        if (n.nodeType === 3) {
          var testo = n.textContent;
          if (!testo.trim()) return;
          var frammento = document.createDocumentFragment();
          testo.split(/(\s+)/).forEach(function (p) {
            if (!p.trim()) { frammento.appendChild(document.createTextNode(p)); return; }
            var fuori = document.createElement('span'); fuori.className = 'b-riga';
            var dentroSpan = document.createElement('span'); dentroSpan.className = 'b-parola';
            dentroSpan.textContent = p;
            fuori.appendChild(dentroSpan); frammento.appendChild(fuori);
            pezzi.push(dentroSpan);
          });
          nodo.replaceChild(frammento, n);
        } else if (n.nodeType === 1 && !n.classList.contains('b-riga')) {
          cammina(n, true);
        }
      });
    })(el, false);
    el.dataset.spezzato = '1';
    return pezzi;
  }

  function tutti(sel, radice) { return Array.prototype.slice.call((radice || document).querySelectorAll(sel)); }

  if (!haGsap || pigro) {
    tutti('[data-rivela]').forEach(function (el) { el.style.opacity = 1; });
    tutti('[data-firma] text, [data-firma] path').forEach(function (t) { t.style.fill = 'var(--b-oro)'; t.style.stroke = 'none'; });
    tutti('[data-conta]').forEach(function (el) {
      var v = parseFloat(el.getAttribute('data-conta')) || 0;
      el.textContent = String(Math.round(v)).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + (el.getAttribute('data-conta-suffisso') || '');
    });
    avviaTeste();
    return;
  }

  /* ---------- rivelazioni ---------- */
  tutti('[data-rivela]').forEach(function (el) {
    var y = parseFloat(el.getAttribute('data-rivela-y') || 34);
    var ritardo = parseFloat(el.getAttribute('data-rivela-ritardo') || 0);
    var figli = el.hasAttribute('data-rivela-gruppo') ? tutti('[data-rivela-figlio]', el) : [];
    gsap.set(el, { opacity: 0, y: y });
    if (figli.length) gsap.set(figli, { opacity: 0, y: y * 0.8 });
    function entra() {
      gsap.to(el, { opacity: 1, y: 0, duration: 1.05, ease: 'power3.out', delay: ritardo });
      if (figli.length) gsap.to(figli, { opacity: 1, y: 0, duration: .95, ease: 'power3.out', stagger: .075, delay: ritardo + .1 });
    }
    // se sta già nello schermo al caricamento (l'eroe, per esempio) deve entrare lo stesso
    if (el.getBoundingClientRect().top < window.innerHeight * 0.88) { entra(); }
    else { ScrollTrigger.create({ trigger: el, start: 'top 88%', once: true, onEnter: entra }); }
  });

  /* ---------- parole che salgono ---------- */
  tutti('[data-parola]').forEach(function (el) {
    var pezzi = spezza(el);
    if (!pezzi || !pezzi.length) return;
    gsap.set(pezzi, { yPercent: 115 });
    function sali() { gsap.to(pezzi, { yPercent: 0, duration: 1.15, ease: 'expo.out', stagger: .045 }); }
    if (el.getBoundingClientRect().top < window.innerHeight * 0.85) { sali(); }
    else { ScrollTrigger.create({ trigger: el, start: 'top 85%', once: true, onEnter: sali }); }
  });

  /* ---------- parallasse ---------- */
  tutti('[data-parallasse]').forEach(function (el) {
    var f = parseFloat(el.getAttribute('data-parallasse')) || 0.12;
    gsap.to(el, {
      yPercent: -f * 100, ease: 'none',
      scrollTrigger: { trigger: el.closest('[data-parallasse-scena]') || el, start: 'top bottom', end: 'bottom top', scrub: true }
    });
  });

  /* ---------- nastri ---------- */
  tutti('[data-marquee]').forEach(function (nastro) {
    var righe = tutti('[data-marquee-riga]', nastro);
    if (!righe.length) return;
    var velocita = parseFloat(nastro.getAttribute('data-marquee-velocita') || 55);
    var verso = parseFloat(nastro.getAttribute('data-marquee-verso') || 1);
    var larghezza = righe[0].offsetWidth;
    var quante = Math.max(2, Math.ceil((window.innerWidth * 2) / Math.max(1, larghezza)) + 1);
    while (righe.length < quante) { var copia = righe[0].cloneNode(true); nastro.appendChild(copia); righe.push(copia); }
    // le righe stanno in fila: si muovono di UNA larghezza e si riavvolgono sempre dentro [-100, 0).
    // Al contrario si parte da -100 e si sale a 0: così a sinistra non resta il buco.
    gsap.set(righe, { xPercent: verso > 0 ? 0 : -100 });
    var ciclo = gsap.to(righe, {
      xPercent: verso > 0 ? -100 : 0, ease: 'none', repeat: -1,
      duration: Math.max(6, larghezza / velocita),
      modifiers: { xPercent: gsap.utils.unitize(gsap.utils.wrap(-100, 0)) }
    });
    ScrollTrigger.create({
      trigger: nastro, start: 'top bottom', end: 'bottom top',
      onUpdate: function (self) { ciclo.timeScale(1 + Math.min(3.4, Math.abs(self.getVelocity() / 900))); },
      onLeave: function () { ciclo.timeScale(1); }, onLeaveBack: function () { ciclo.timeScale(1); }
    });
  });

  /* ---------- pista orizzontale ---------- */
  tutti('[data-pin]').forEach(function (scena) {
    var strada = scena.querySelector('[data-pin-strada]');
    if (!strada) return;
    // anche sul telefono: scorrendo in giù la pista avanza di lato, altrimenti
    // quella sezione non la guarda nessuno (deciso da Luigi il 2026-09-02).
    var corsa = function () { return Math.max(0, strada.scrollWidth - window.innerWidth); };
    gsap.to(strada, {
      x: function () { return -corsa(); }, ease: 'none',
      scrollTrigger: {
        trigger: scena, start: 'top top', end: function () { return '+=' + corsa(); },
        pin: true, scrub: 1, invalidateOnRefresh: true, anticipatePin: 1
      }
    });
  });

  /* ---------- numeri che contano ---------- */
  function formatta(n) { return String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
  tutti('[data-conta]').forEach(function (el) {
    var fine = parseFloat(el.getAttribute('data-conta')) || 0;
    var suff = el.getAttribute('data-conta-suffisso') || '';
    var obj = { n: 0 };
    ScrollTrigger.create({
      trigger: el, start: 'top 88%', once: true,
      onEnter: function () {
        gsap.to(obj, {
          n: fine, duration: 1.8, ease: 'power2.out',
          onUpdate: function () { el.textContent = formatta(Math.round(obj.n)) + suff; }
        });
      }
    });
  });

  /* ---------- bottoni magnetici ---------- */
  if (window.matchMedia('(hover:hover) and (pointer:fine)').matches) {
    tutti('[data-magnetico]').forEach(function (el) {
      var forza = parseFloat(el.getAttribute('data-magnetico') || 0.3);
      el.addEventListener('mousemove', function (e) {
        var r = el.getBoundingClientRect();
        gsap.to(el, { x: (e.clientX - r.left - r.width / 2) * forza, y: (e.clientY - r.top - r.height / 2) * forza, duration: .5, ease: 'power3.out' });
      });
      el.addEventListener('mouseleave', function () { gsap.to(el, { x: 0, y: 0, duration: .7, ease: 'elastic.out(1,.4)' }); });
    });
  }

  /* ---------- l'arco dell'eroe ---------- */
  tutti('[data-arco]').forEach(function (el) {
    gsap.fromTo(el, { clipPath: 'inset(0 0 100% 0)', scale: 1.06 }, { clipPath: 'inset(0 0 0% 0)', scale: 1, duration: 1.6, ease: 'expo.out', delay: .15 });
    gsap.to(el, { yPercent: -8, ease: 'none', scrollTrigger: { trigger: el.closest('section') || el, start: 'top top', end: 'bottom top', scrub: true } });
  });

  /* ---------- il header cambia colore sopra le sezioni scure ---------- */
  function avviaTeste() {
    var testa = document.querySelector('.b-testa');
    if (!testa) return;
    if (!haGsap) { return; }
    tutti('[data-testa="scura"]').forEach(function (s) {
      ScrollTrigger.create({
        trigger: s, start: 'top 60px', end: 'bottom 60px',
        onToggle: function (self) { testa.classList.toggle('on-scuro', self.isActive); }
      });
    });
  }
  avviaTeste();

  /* ---------- L'APERTURA: una scena sola, bloccata, in quattro atti ----------
     Studiata fotogramma per fotogramma sul riferimento (studio/fitto/).
       atto 1  il pannello crema si rimpicciolisce in una scheda e va in bianco e nero:
               attorno resta il nero coi nastri
       atto 2  la firma si scrive sopra la scheda
       atto 3  scheda e firma salgono e lasciano il posto al resto della pagina */
  tutti('[data-apertura]').forEach(function (sez) {
    /* [data-ap-regia]: la coreografia la scrive un altro file (la notte di Halloween, bold-notte.js) */
    if (sez.hasAttribute('data-ap-regia')) return;
    var scena = sez.querySelector('[data-ap-scena]');
    var pannello = sez.querySelector('[data-ap-pannello]');
    if (!scena || !pannello) return;
    var firma = sez.querySelector('[data-ap-firma]');
    var cartellino = sez.querySelector('[data-ap-cartellino]');
    var dritta = sez.querySelector('[data-ap-dritta]');

    var tratti = firma ? tutti('path, text', firma) : [];
    tratti.forEach(function (t) {
      var L = 1500;
      try { if (t.getTotalLength) L = Math.max(600, t.getTotalLength()); } catch (e) {}
      gsap.set(t, { strokeDasharray: L, strokeDashoffset: L });
    });

    var tl = gsap.timeline({
      scrollTrigger: {
        trigger: sez, start: 'top top', end: 'bottom bottom',
        pin: scena, scrub: .7, anticipatePin: 1, invalidateOnRefresh: true
      }
    });

    // atto 1 — il pannello si stringe, la fotografia perde il colore
    if (dritta) tl.to(dritta, { opacity: 0, duration: .04 }, 0.12);
    if (cartellino) tl.to(cartellino, { opacity: 0, duration: .06 }, 0.14);
    gsap.set(pannello, { filter: 'grayscale(0) contrast(1) brightness(1)' });
    tl.to(pannello, { scale: .30, borderRadius: 20, duration: .34, ease: 'power2.inOut' }, 0.16);
    /* [data-ap-colore]: la scheda resta a colori (la notte di Halloween: le zucche accese) */
    if (!sez.hasAttribute('data-ap-colore')) {
      tl.to(pannello, { filter: 'grayscale(1) contrast(1.06) brightness(1)', duration: .22, ease: 'none' }, 0.22);
    }

    // atto 2 — la firma si scrive
    if (tratti.length) {
      tl.to(tratti, { strokeDashoffset: 0, ease: 'none', duration: .30, stagger: .03 }, 0.34)
        .to(tratti, { fillOpacity: 1, duration: .10, ease: 'power1.out' }, 0.66);
    }

    // atto 3 — scheda e firma salgono e sfumano
    tl.to([pannello, firma].filter(Boolean), { yPercent: -16, opacity: 0, duration: .16, ease: 'power2.in' }, 0.82);
  });

  /* ---------- il faro che svela la seconda fotografia ----------
     [data-svela] sulla figura, [data-svela-sopra] sulla foto che si scopre,
     [data-svela-griglia] sulla rete che si sposta piano.
     Il cursore vero viene inseguito con un'attenuazione di 0,1; il raggio del
     faro va da 160 a 420 px secondo la larghezza. */
  tutti('[data-svela]').forEach(function (scena) {
    var sopra = scena.querySelector('[data-svela-sopra]');
    if (!sopra) return;
    if (!window.matchMedia('(hover:hover) and (pointer:fine)').matches) { scena.classList.add('senza-faro'); return; }
    var rete = scena.querySelector('[data-svela-griglia]');
    var m = { x: window.innerWidth / 2, y: window.innerHeight / 2 };
    var s2 = { x: m.x, y: m.y }, g = { x: 0, y: 0 };
    window.addEventListener('mousemove', function (e) { m.x = e.clientX; m.y = e.clientY; }, { passive: true });
    scena.classList.add('col-faro');
    gsap.ticker.add(function () {
      s2.x += (m.x - s2.x) * 0.1;
      s2.y += (m.y - s2.y) * 0.1;
      var b = scena.getBoundingClientRect();
      if (!b.width) return;
      var r = Math.round(Math.min(420, Math.max(160, window.innerWidth * 0.16)));
      sopra.style.setProperty('--faro-x', (s2.x - b.left).toFixed(1) + 'px');
      sopra.style.setProperty('--faro-y', (s2.y - b.top).toFixed(1) + 'px');
      sopra.style.setProperty('--faro-r', r + 'px');
      if (rete) {
        var cx = (s2.x - b.left) / b.width - 0.5, cy = (s2.y - b.top) / b.height - 0.5;
        g.x += (cx * 16 - g.x) * 0.06;
        g.y += (cy * 16 - g.y) * 0.06;
        rete.style.transform = 'translate(' + g.x.toFixed(2) + 'px,' + g.y.toFixed(2) + 'px)';
      }
    });
  });

  /* ---------- le sezioni si accavallano: quella che sale copre la precedente ----------
     [data-copre] sulla sezione che sale. La sezione PRIMA di lei resta ferma,
     si rimpicciolisce e si scurisce mentre l'altra le passa sopra: è il passaggio
     che tiene insieme l'apertura e il resto della pagina. */
  tutti('[data-copre]').forEach(function (sez) {
    var prima = sez.previousElementSibling;
    if (!prima) return;
    ScrollTrigger.create({
      trigger: prima, start: 'top top', end: 'bottom top',
      pin: true, pinSpacing: false, anticipatePin: 1
    });
    gsap.fromTo(prima.firstElementChild ? prima : prima,
      { scale: 1, filter: 'brightness(1)' },
      {
        scale: 0.9, filter: 'brightness(.76)', ease: 'none', transformOrigin: '50% 42%',
        scrollTrigger: { trigger: sez, start: 'top bottom', end: 'top top', scrub: .4 }
      });
    gsap.set(sez, { zIndex: 5, position: 'relative' });
  });

  /* ---------- una scheda che resta ferma mentre la sezione le scorre attorno ---------- */
  tutti('[data-ferma]').forEach(function (el) {
    var scena = el.closest('section');
    if (!scena || window.innerWidth < 750) return;
    ScrollTrigger.create({
      trigger: scena, start: 'top top', end: 'bottom bottom',
      pin: el, pinSpacing: false
    });
  });

  /* ---------- la firma che si scrive ---------- */
  tutti('[data-firma]').forEach(function (svg) {
    var tratti = tutti('path, text', svg);
    if (!tratti.length) return;
    svg.setAttribute('data-firma-pronta', '');
    tratti.forEach(function (t, i) {
      var L = 1400;
      try { if (t.getTotalLength) L = Math.max(400, t.getTotalLength()); } catch (e) {}
      gsap.set(t, { strokeDasharray: L, strokeDashoffset: L, fill: 'none' });
      var tl = gsap.timeline({
        scrollTrigger: { trigger: svg.closest('section') || svg, start: 'top 62%', end: 'center 46%', scrub: .7 }
      });
      tl.to(t, { strokeDashoffset: 0, ease: 'none', duration: 1 }, i * 0.06);
    });
  });

  /* ---------- il header si ritira quando scendi ---------- */
  (function () {
    var testa = document.querySelector('.b-testa');
    if (!testa) return;
    ScrollTrigger.create({
      start: 0, end: 'max',
      onUpdate: function (self) {
        testa.classList.toggle('is-via', self.direction === 1 && self.scroll() > 260);
        /* appena si scende, il header si porta dietro un fondo: quando torna su
           sopra una sezione nera, senza fondo il marchio non si vedeva. */
        testa.classList.toggle('ha-fondo', self.scroll() > 30);
      }
    });
  })();

  (function () {
    /* senza GSAP (moto ridotto) il fondo del header lo mette lo scroll nudo */
    var testa = document.querySelector('.b-testa');
    if (!testa || haGsap) return;
    var guarda = function () { testa.classList.toggle('ha-fondo', window.scrollY > 30); };
    window.addEventListener('scroll', guarda, { passive: true });
    guarda();
  })();

  ScrollTrigger.refresh();
  window.addEventListener('load', function () { ScrollTrigger.refresh(); });
})();
